/* MANHAUS DEALS — banda 3D, aire en movimiento, historia con scroll y compra directa */
(function () {
  if (window.__mhDeals) return;
  window.__mhDeals = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fino = window.matchMedia('(pointer: fine)').matches;

  function enVista(el, cb, opciones) {
    if (!('IntersectionObserver' in window)) { cb(true); return null; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { cb(e.isIntersecting, e); }); }, opciones || { threshold: 0.2 });
    io.observe(el);
    return io;
  }

  /* ---------- Apertura: banda 3D + luz + etiquetas + aire ---------- */
  function initHero(hero) {
    if (hero.hasAttribute('data-mh-listo')) return;
    hero.setAttribute('data-mh-listo', '');
    var escena = hero.querySelector('[data-mh-escena]');
    var giro = hero.querySelector('.mh-tira3d__giro');
    var frente = hero.querySelector('.mh-tira3d__frente');
    var flotas = [].slice.call(hero.querySelectorAll('.mh-deal-flota'));
    var luz = hero.querySelector('.mh-deal-hero__luz');
    var visible = true, px = 0, py = 0, sx = 0, sy = 0;
    var extra = 0, vel = 0, arrastrando = false, ultimoX = 0, t0 = performance.now();

    // luz que sigue al mouse + paralaje de etiquetas
    if (fino && !reduce) {
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        if (luz) {
          luz.style.setProperty('--mx', (e.clientX - r.left).toFixed(0) + 'px');
          luz.style.setProperty('--my', (e.clientY - r.top).toFixed(0) + 'px');
        }
        if (!escena) return;
        var re = escena.getBoundingClientRect();
        px = Math.max(-1, Math.min(1, (e.clientX - (re.left + re.width / 2)) / (re.width / 2)));
        py = Math.max(-1, Math.min(1, (e.clientY - (re.top + re.height / 2)) / (re.height / 2)));
        flotas.forEach(function (f) {
          var k = parseFloat(f.getAttribute('data-prof')) || 1;
          f.style.setProperty('--px', (px * k * 16).toFixed(1) + 'px');
          f.style.setProperty('--py', (py * k * 12).toFixed(1) + 'px');
        });
      }, { passive: true });
      hero.addEventListener('mouseleave', function () { px = 0; py = 0; });
    }

    // girar con el dedo o el mouse
    if (escena && giro) {
      escena.addEventListener('pointerdown', function (e) {
        arrastrando = true; ultimoX = e.clientX; vel = 0;
        escena.classList.add('mh-arrastrando', 'mh-girada');
        try { escena.setPointerCapture(e.pointerId); } catch (err) {}
      });
      escena.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        var dx = e.clientX - ultimoX; ultimoX = e.clientX;
        extra += dx * 0.55; vel = dx * 0.55;
        if (reduce) pintar(performance.now());
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) {
        escena.addEventListener(ev, function () { arrastrando = false; escena.classList.remove('mh-arrastrando'); });
      });
    }

    function pintar(ahora) {
      if (!giro) return;
      var t = (ahora - t0) / 1000;
      if (!arrastrando) { vel *= 0.94; extra += vel; }
      sx += (px - sx) * 0.06; sy += (py - sy) * 0.06;
      var mov = reduce ? 0 : 1;
      var ry = (Math.sin(t * 0.45) * 26 - 10) * mov + extra + sx * 16;
      var rx = 16 + Math.sin(t * 0.6) * 6 * mov - sy * 12;
      var rz = -7 + Math.sin(t * 0.35) * 3 * mov;
      giro.style.setProperty('--ry', ry.toFixed(2) + 'deg');
      giro.style.setProperty('--rx', rx.toFixed(2) + 'deg');
      giro.style.setProperty('--rz', rz.toFixed(2) + 'deg');
      if (frente) frente.style.setProperty('--brillo', (50 - Math.sin(ry * Math.PI / 180) * 55).toFixed(1) + '%');
    }

    // aire: partículas que fluyen hacia la banda
    var canvas = hero.querySelector('[data-mh-aire]');
    var ctx = canvas && canvas.getContext ? canvas.getContext('2d') : null;
    var W = 0, H = 0, cx = 0, cy = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), parts = [];
    function medir() {
      if (!ctx) return;
      var r = hero.getBoundingClientRect();
      W = r.width; H = r.height;
      canvas.width = W * dpr; canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (escena) { var re = escena.getBoundingClientRect(); cx = re.left - r.left + re.width / 2; cy = re.top - r.top + re.height / 2; }
      else { cx = W / 2; cy = H / 2; }
      var n = W < 750 ? 26 : 56;
      parts = [];
      for (var i = 0; i < n; i++) parts.push(nueva(true));
    }
    function nueva(azar) {
      return { lado: Math.random() < 0.5 ? -1 : 1, p: azar ? Math.random() : 0, v: 0.0025 + Math.random() * 0.004, carril: (Math.random() - 0.5) * H * 0.7, fase: Math.random() * 6.28, oro: Math.random() < 0.35, largo: 10 + Math.random() * 26 };
    }
    function pos(o, p) {
      var borde = o.lado < 0 ? -40 : W + 40;
      var dest = cx + o.lado * Math.min(W * 0.12, 120);
      var e = 1 - Math.pow(1 - p, 2);
      return [borde + (dest - borde) * e, cy + o.carril * Math.pow(1 - p, 1.3) + Math.sin(p * 7 + o.fase) * 10 * (1 - p)];
    }
    function aire() {
      if (!ctx) return;
      ctx.clearRect(0, 0, W, H);
      ctx.lineCap = 'round';
      var rapido = arrastrando || Math.abs(vel) > 1 ? 2.2 : 1;
      parts.forEach(function (o, i) {
        o.p += o.v * rapido;
        if (o.p >= 1) { parts[i] = nueva(false); return; }
        var a = pos(o, o.p), b = pos(o, Math.max(0, o.p - o.largo / 1000));
        var alfa = Math.sin(o.p * Math.PI) * (o.oro ? 0.6 : 0.34);
        var acento = hero.getAttribute('data-modo') === 'noche' ? '246,238,216,' : '212,255,58,';
        ctx.strokeStyle = o.oro ? 'rgba(' + acento + alfa.toFixed(3) + ')' : 'rgba(255,255,255,' + alfa.toFixed(3) + ')';
        ctx.lineWidth = o.oro ? 1.6 : 1.1;
        ctx.beginPath(); ctx.moveTo(b[0], b[1]); ctx.lineTo(a[0], a[1]); ctx.stroke();
      });
    }

    function bucle(ahora) {
      if (!visible) { hero.__mhRaf = 0; return; }
      pintar(ahora);
      if (!reduce) aire();
      hero.__mhRaf = requestAnimationFrame(bucle);
    }
    medir();
    window.addEventListener('resize', medir, { passive: true });
    enVista(hero, function (si) {
      visible = si;
      if (si && !hero.__mhRaf) hero.__mhRaf = requestAnimationFrame(bucle);
    }, { threshold: 0 });
    if (reduce) pintar(performance.now());

    // barra fija en celular
    var barra = hero.querySelector('[data-mh-deal-barra]');
    var compra = hero.querySelector('[data-mh-deal-compra]');
    if (barra && compra) {
      enVista(compra, function (si, e) {
        var pasado = e ? e.boundingClientRect.top < 0 : false;
        barra.classList.toggle('mh-visible', !si && pasado);
        barra.setAttribute('aria-hidden', !si && pasado ? 'false' : 'true');
        var btn = barra.querySelector('button'); if (btn) btn.tabIndex = !si && pasado ? 0 : -1;
      }, { threshold: 0 });
    }
  }

  /* ---------- Inclinación 3D con brillo ---------- */
  function initTilt(root) {
    if (!fino || reduce) return;
    (root || document).querySelectorAll('[data-mh-tilt]:not([data-mh-tilt-listo])').forEach(function (el) {
      el.setAttribute('data-mh-tilt-listo', '');
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        el.style.setProperty('--ty', ((x - 0.5) * 10).toFixed(2) + 'deg');
        el.style.setProperty('--tx', ((0.5 - y) * 8).toFixed(2) + 'deg');
        el.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      });
      el.addEventListener('mouseleave', function () { el.style.setProperty('--tx', '0deg'); el.style.setProperty('--ty', '0deg'); });
    });
  }

  /* ---------- Cómo funciona: pasos que cambian la ilustración ---------- */
  function initFunciona(root) {
    (root || document).querySelectorAll('[data-mh-func]:not([data-mh-listo])').forEach(function (s) {
      s.setAttribute('data-mh-listo', '');
      // la ilustración fija se ubica justo debajo del encabezado fijo de la tienda
      var cab = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
      function altoCab() { if (cab) s.style.setProperty('--mh-cab', Math.max(0, cab.getBoundingClientRect().height) + 'px'); }
      altoCab(); window.addEventListener('resize', altoCab, { passive: true });
      enVista(s, function (si) { if (si) s.classList.add('mh-en-vista'); }, { threshold: 0.15 });
      var pasos = [].slice.call(s.querySelectorAll('[data-mh-paso]'));
      if (pasos[0]) pasos[0].classList.add('mh-activo');
      // el paso activo es el último cuyo inicio ya pasó la mitad de la pantalla
      var pendiente = false;
      function elegir() {
        pendiente = false;
        var mitad = window.innerHeight * 0.55, activo = pasos[0];
        pasos.forEach(function (p) { if (p.getBoundingClientRect().top < mitad) activo = p; });
        if (!activo || activo.classList.contains('mh-activo')) return;
        pasos.forEach(function (x) { x.classList.toggle('mh-activo', x === activo); });
        s.setAttribute('data-paso', activo.getAttribute('data-mh-paso'));
      }
      window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(elegir); } }, { passive: true });
      elegir();
    });
  }

  /* ---------- Mes de bandas + línea de pasos ---------- */
  function initEnVista(root) {
    (root || document).querySelectorAll('[data-mh-mes]:not([data-mh-listo]), [data-mh-pasos]:not([data-mh-listo])').forEach(function (el) {
      el.setAttribute('data-mh-listo', '');
      var io = enVista(el, function (si) {
        if (!si) return;
        el.classList.add('mh-en-vista');
        var c = el.querySelector('[data-mh-mes-cuenta]');
        if (c) {
          var fin = el.querySelectorAll('.mh-deal-mes__grid i').length, ini = performance.now(), dur = reduce ? 1 : fin * 45 + 400;
          (function paso(ahora) {
            var k = Math.min(1, (ahora - ini) / dur);
            c.textContent = Math.round(fin * k);
            if (k < 1) requestAnimationFrame(paso);
          })(ini);
        }
        if (io) io.disconnect();
      }, { threshold: 0.35 });
    });
  }

  /* ---------- Compra: directo al pago o al carrito ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mh-deal-comprar]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var destino = b.getAttribute('data-destino') || 'checkout';
    var zona = b.closest('[data-mh-deal-compra], .mh-deal-incluye__compra, section');
    var error = zona && zona.querySelector('[data-mh-deal-error]');
    if (error) error.hidden = true;
    var drawer = document.querySelector('cart-drawer');
    var cantidad = parseInt(b.getAttribute('data-cantidad'), 10) || 1;
    var body = { items: [{ id: parseInt(b.getAttribute('data-mh-deal-comprar'), 10), quantity: cantidad }] };
    if (destino === 'carrito' && drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
    b.classList.add('mh-cargando');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        if (destino === 'checkout') { if (window.mhIrAPagar) window.mhIrAPagar().then(function () { b.classList.remove('mh-cargando'); }); else location.href = '/checkout'; return; }
        b.classList.remove('mh-cargando');
        if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
        else location.href = '/cart';
      })
      .catch(function (err) {
        b.classList.remove('mh-cargando');
        if (error) { error.textContent = (err && err.message) || 'No pudimos agregarlo. Probá de nuevo.'; error.hidden = false; }
      });
  });

  /* ---------- Día / Noche: el interruptor mueve la frontera entre los dos cielos ---------- */
  function initDiaNoche(s) {
    if (s.hasAttribute('data-mh-dn-listo')) return;
    s.setAttribute('data-mh-dn-listo', '');
    var botones = [].slice.call(s.querySelectorAll('[data-mh-modo]'));
    var segundos = parseInt(s.getAttribute('data-auto'), 10) || 0;
    var tocado = false, visible = true, reloj = null;
    function poner(modo) {
      s.setAttribute('data-modo', modo);
      botones.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-mh-modo') === modo ? 'true' : 'false'); });
    }
    botones.forEach(function (b) {
      b.addEventListener('click', function () { tocado = true; clearInterval(reloj); poner(b.getAttribute('data-mh-modo')); });
    });
    if (segundos && !reduce) {
      reloj = setInterval(function () {
        if (tocado || !visible || document.hidden) return;
        poner(s.getAttribute('data-modo') === 'dia' ? 'noche' : 'dia');
      }, segundos * 1000);
      enVista(s, function (si) { visible = si; }, { threshold: 0.3 });
    }
  }

  /* ---------- Tus 24 horas: la línea del día se llena con el scroll normal (nada queda fijo) ---------- */
  function init24(root) {
    (root || document).querySelectorAll('[data-mh-24]:not([data-mh-listo])').forEach(function (s) {
      s.setAttribute('data-mh-listo', '');
      var momentos = [].slice.call(s.querySelectorAll('[data-mh-24-momento]'));
      var dia = s.querySelector('.mh-24__dia');
      var riel = s.querySelector('.mh-24__riel');
      if (!momentos.length || !dia) return;
      if (!reduce && 'IntersectionObserver' in window) {
        s.classList.add('mh-24--js');
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('mh-en-vista'); io.unobserve(e.target); } });
        }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
        momentos.forEach(function (m) { io.observe(m); });
      }
      // el día avanza según cuánto de la línea ya pasó por el centro de la pantalla
      var pendiente = false, vertical = window.matchMedia('(max-width: 749px)');
      function pintar() {
        pendiente = false;
        var mitad = window.innerHeight * 0.6;
        var r = dia.getBoundingClientRect();
        if (vertical.matches) {
          // celular: la línea baja junto con las tarjetas, cada punto se enciende al pasar la mitad
          var p = Math.min(1, Math.max(0, (mitad - r.top - 26) / Math.max(1, r.height - 52)));
          momentos.forEach(function (m) { m.classList.toggle('mh-pasado', m.getBoundingClientRect().top + 29 <= mitad); });
        } else {
          // computadora: la línea horizontal se llena de amanecer a noche mientras la fila cruza la pantalla
          var p = Math.min(1, Math.max(0, (window.innerHeight * 0.85 - r.top) / (window.innerHeight * 0.6)));
          momentos.forEach(function (m, j) { m.classList.toggle('mh-pasado', p > 0 && p >= j / Math.max(1, momentos.length - 1) - 0.001); });
        }
        if (riel) riel.style.setProperty('--p', p.toFixed(4));
      }
      function pedir() { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }
      window.addEventListener('scroll', pedir, { passive: true });
      window.addEventListener('resize', pedir, { passive: true });
      pintar();
    });
  }

  /* ---------- Testimonios en video: vista previa sin sonido, al tocar con sonido ---------- */
  function initTestimonios(root) {
    (root || document).querySelectorAll('[data-mh-testis]:not([data-mh-listo])').forEach(function (s) {
      s.setAttribute('data-mh-listo', '');
      var tarjetas = [].slice.call(s.querySelectorAll('[data-mh-testi]'));
      function silenciar(t) {
        var v = t.querySelector('video'); if (!v) return;
        v.muted = true; v.loop = true;
        t.classList.remove('mh-sonando', 'mh-pausado');
        if (reduce || !t._visible) v.pause();
      }
      tarjetas.forEach(function (t) {
        var v = t.querySelector('[data-mh-testi-video]');
        var boton = t.querySelector('[data-mh-testi-sonido]');
        var barra = t.querySelector('.mh-testi__barra');
        if (!v || !boton) return;
        // vista previa: se mueve sin sonido solo mientras se ve en pantalla
        enVista(t, function (si) {
          t._visible = si;
          if (t.classList.contains('mh-sonando')) { if (!si) { v.pause(); t.classList.add('mh-pausado'); } return; }
          if (si && !reduce) { v.preload = 'auto'; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else v.pause();
        }, { threshold: 0.5 });
        var toqueT;
        function toque() { t.classList.add('mh-toque'); clearTimeout(toqueT); toqueT = setTimeout(function () { t.classList.remove('mh-toque'); }, 900); }
        boton.addEventListener('click', function () {
          toque();
          if (!t.classList.contains('mh-sonando')) {
            tarjetas.forEach(function (o) { if (o !== t) silenciar(o); });
            v.muted = false; v.loop = false; v.currentTime = 0;
            t.classList.add('mh-sonando'); t.classList.remove('mh-pausado');
            boton.setAttribute('aria-label', 'Pausar video');
            var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
          } else if (v.paused) {
            t.classList.remove('mh-pausado'); v.play();
          } else {
            t.classList.add('mh-pausado'); v.pause();
          }
        });
        v.addEventListener('timeupdate', function () {
          if (barra && v.duration) barra.style.setProperty('--p', (v.currentTime / v.duration).toFixed(4));
        });
        v.addEventListener('ended', function () {
          silenciar(t);
          boton.setAttribute('aria-label', boton.getAttribute('data-etiqueta') || 'Ver con sonido');
          v.currentTime = 0;
          if (t._visible && !reduce) v.play();
        });
        boton.setAttribute('data-etiqueta', boton.getAttribute('aria-label'));
      });
    });
  }

  function initTodo(root) {
    (root || document).querySelectorAll('[data-mh-deal-hero]').forEach(initHero);
    (root || document).querySelectorAll('[data-mh-dn]').forEach(initDiaNoche);
    initTilt(root); initFunciona(root); initEnVista(root); init24(root); initTestimonios(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  else initTodo(document);
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
